module.exports = __webpack_public_path__ + "76e9028f71b6f1b2334cbf6afd7c2419.pdf";